import React from "react";

const TaboolaChannelIcon = ({
  color,
  className,
}: {
  color: string;
  className?: string;
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 414.7 361.6"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <g>
          <path
            fill={color}
            d="M123.4,88.5c-25.7-0.2-29.3,24.9-29.4,43.7c-0.1,18.9,3.2,44.3,28.9,44.4c25.7,0.1,29.3-25.2,29.4-44.1
            C152.4,113.7,149.1,88.6,123.4,88.5 M122.6,226c-66.9-0.4-96.8-44.8-96.5-94.2c0.3-49.4,30.7-93.1,97.6-92.7
            c66.9,0.4,96.8,44.4,96.5,93.8C219.9,182.3,189.4,226.3,122.6,226"
          />
          <path
            fill={color}
            d="M291.8,88.5c-25.7-0.2-29.3,24.9-29.4,43.7c-0.1,18.9,3.2,44.2,28.9,44.4c25.7,0.2,29.3-25.2,29.4-44.1
            C320.8,113.7,317.5,88.6,291.8,88.5 M291,226c-66.8-0.4-96.8-44.8-96.5-94.2c0.3-49.4,30.7-93.1,97.5-92.7
            c66.8,0.4,96.8,44.4,96.5,93.8C388.3,182.3,357.9,226.3,291,226"
          />
          <path
            fill={color}
            d="M51.6,226c48.2,21.5,98.2,31.1,152.7,31.4c57.2,0.3,100.7-10.5,155.6-31.4l-0.3,59.3
            c-49.2,24.4-102.5,37.5-155.7,37.2c-57.9-0.3-99.7-12.2-152.7-37.2L51.6,226z M51.6,226"
          />
        </g>
      </g>
    </svg>
  );
};

export default TaboolaChannelIcon;
